import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { managementService } from "../../../../configs/constants";

interface ManagerOption {
  id: string;
  name: string;
  email: string;
}

export const useManagers = () => {
  const [options, setOptions] = useState<ManagerOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  // Memoized fetch function
  const fetchManagers = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const managersUrl = `${managementService}/landlord/user`;
      const url = `${managersUrl}?page=${1}`;

      const { data } = await axios.get(url);

      const formattedOptions: ManagerOption[] = data?.result?.data?.map((user: any) => ({
        id: user.userId,
        name: user.name,
        email: user.email,
      }));

      setOptions(formattedOptions);
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [managementService]);

  // Call fetch on mount or when dependencies change
  useEffect(() => {
    fetchManagers();
  }, [fetchManagers]);

  return { options, loading, error, fetchManagers };
};
